import React, { useRef, useState } from "react";
import { Overlay, Popover, Col, Row, Form } from "react-bootstrap";
import filter from "../../assets/images/filt.svg";
import close from "../../assets/images/close.svg";


function StaffFilter(props) {
  const [show, setShow] = useState(false);
  const [value, setValue] = useState("");
  const [role, setRole] = useState("");

  const { error, onSubmit, reset } = props;

  const [target, setTarget] = useState(null);
  const ref = useRef(null);

  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const handleClose = () => {
    setShow(false);
    setTarget(null);
  };

  const status = [
    { id: 0, value: "Active" },
    { id: 1, value: "Inactive" },
  ];

  const roles = [
    { id: 1, value: "Staff" },
    { id: 2, value: "Sales Executive" },
  ]

  const filterChange = (e) => {
    const target = e.target;
    var value = target.value;
    setValue(value);
  }

  const roleChange = (e) => {
    const target = e.target;
    var value = target.value;
    setRole(value);
  }

  const submitHandler = (e) => {
    e.preventDefault();

    let data = {
      "status": value === "" ? "" : value === "Active" ? 1 : 0,
      "role": role.toUpperCase()
    }
    onSubmit(data);
    setTarget(null);
    setShow(false);
  }

  const resetHandler = () => {
    reset();
    setValue("");
    setRole("");
    setTarget(null);
    setShow(false);
  }


  return (
    <div ref={ref} className="filter-background">
      <button onClick={handleClick} className="filter-button staff">
        <img src={filter} alt="..." width="18px" style={{ paddingRight: "5px" }} /> Filter
      </button>

      <Overlay
        show={show}
        target={target}
        placement="bottom"
        container={ref}
        containerPadding={20}
      >
        <Popover id="popover-contained">
          <Popover.Header>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <p style={{ margin: 0 }}>Status</p>
              <img
                src={close}
                alt="Close"
                width="16px"
                style={{ cursor: "pointer", marginLeft: 'auto' }}
                onClick={handleClose}
              />
            </div>
          </Popover.Header>
          <Popover.Body>
            <div className="filter-page">
              <Form onSubmit={submitHandler}>
                <Form.Group controlId="formBasicStatus">
                  <Form.Select
                    value={value}
                    onChange={filterChange}
                    className="form-control"
                  >
                    <option value="">Select Status</option>
                    {status.map((item) => (
                      <option key={item.id} value={item.value}>
                        {item.value}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <p>Role</p>
                <Form.Group controlId="formBasicRole">
                  <Form.Select
                    value={role}
                    onChange={roleChange}
                    className="form-control"
                  >
                    <option value="">Select Role</option>
                    {roles.map((item) => (
                      <option key={item.id} value={item.value}>
                        {item.value}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <div>
                  <Row>
                    <Col md={6}>
                      <button className="modal-price reset" type="button" onClick={resetHandler}>
                        Reset
                      </button>
                    </Col>
                    <Col md={6}>
                      <button type="submit" className="modal-btn modal-apply">
                        Apply
                      </button>
                    </Col>
                  </Row>
                </div>
              </Form>
            </div>
          </Popover.Body>
        </Popover>
      </Overlay>
    </div>
  );
}


export default StaffFilter;

